module.exports = __webpack_public_path__ + "static/media/11_twitter_image.e7d55f21.jpg";